import { render, staticRenderFns } from "./MyPositionProMain.vue?vue&type=template&id=49a9b8e2&scoped=true&"
import script from "./MyPositionProMain.vue?vue&type=script&lang=js&"
export * from "./MyPositionProMain.vue?vue&type=script&lang=js&"
import style0 from "./MyPositionProMain.vue?vue&type=style&index=0&id=49a9b8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a9b8e2",
  null
  
)

export default component.exports